import { Cart, useCart } from 'components/Cart';
import React, { useEffect, useState } from 'react';

import { clearShippingMethodId } from '../../../utils/cartHelpers';
import {
  hasSubscriptionItemInCart,
  hasLabVisitItemInCart,
} from '../../../utils/helpers/paymentHelpers';

export type CartContainerProps = {};

export const CartContainer = (props: CartContainerProps) => {
  const { order } = useCart();

  const [showAltPayments, setShowAltPayments] = useState(false);

  // ---REMOVE hasLabVisitItemInCart LOGIC WHEN EXPRESS PAY IN BDC CARTS IS FIXED (below this line)---

  // Show alternative payment buttons (PayPal/Express Pay)
  useEffect(() => {
    const lineItems = order?.line_items || [];
    const showAltPaymentButtons =
      !hasSubscriptionItemInCart(lineItems) &&
      !hasLabVisitItemInCart(lineItems);

    setShowAltPayments(showAltPaymentButtons);

    // set the shipping method back to standard when the cart is empty
    if (!lineItems.length) {
      clearShippingMethodId();
    }
  }, [order]);
  // ---REMOVE hasLabVisitItemInCart LOGIC WHEN EXPRESS PAY IN BDC CARTS IS FIXED (above this line)---

  const cartProps = {
    showAltPayments,
  };

  return <Cart {...cartProps} />;
};

export default CartContainer;
